import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { init } from '@sentry/angular-ivy';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppInjector } from './app/app.injector';

const initSmartlook = (): void => {
  if (!window.smartlook) {
    (function createSmartlookStuff(d) {
      // eslint-disable-next-line no-multi-assign
      const o: SmartlookFunction = (window.smartlook = function smartlookMainFunction(...args) {
        o.api.push(args);
      });
      const h = d.getElementsByTagName('head')[0];
      const c = d.createElement('script');
      o.api = [];
      c.async = true;
      c.type = 'text/javascript';
      c.charset = 'utf-8';
      c.src = 'https://web-sdk.smartlook.com/recorder.js';
      h.appendChild(c);
    })(document);
  }
  window.smartlook('init', '030379ef26b193fe2e8eef476a9511357dab88de', { region: 'eu' });
};

const initMatomo = (config: { active: boolean; url: string; siteId: number; scriptUrl?: string }): void => {
  if (!config.active) {
    return;
  }

  window._paq = window._paq || [];
  window._paq.push(['setDocumentTitle', 'Index - Lundify Workflow']);
  window._paq.push(['trackPageView']);
  window._paq.push(['enableLinkTracking']);

  // Note: If we want to enable heatmaps later, remeber to have a look at how the calling with window._paq works because it get stuck in NgZone calls (for head-element for some reason). Run outside Angular zone might be needed.
  window._paq.push(['HeatmapSessionRecording::disable']);
  // window._paq.push(['HeatmapSessionRecording::disableAutoDetectNewPageView']);

  (() => {
    const u = config.url;
    window._paq.push(['setTrackerUrl', `${u}matomo.php`]);
    window._paq.push(['setSiteId', config.siteId.toString()]);
    const d = document;
    const g = d.createElement('script');
    const s = d.getElementsByTagName('script')[0];
    g.type = 'text/javascript';
    g.async = true;
    g.defer = true;
    g.src = config.scriptUrl || `${u}matomo.js`;
    s.parentNode.insertBefore(g, s);
  })();
};

// Initialize Matomo for all environments (will only load if active is true)
// This is to track also non-production environments (Maybe just have it inside production block?)
initMatomo(environment.matomo);

if (environment.production) {
  init({
    dsn: 'https://3e0b5d2db4fa4eb38bdf541be6c7fa01@o356905.ingest.sentry.io/5785908',
    environment: environment.name,
    release: environment.version,
  });

  initSmartlook();
  // initMatomo(environment.matomo);
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((appRef) => {
    // To be able to inject services into non-angular classes
    AppInjector.set(appRef.injector);
  })
  // eslint-disable-next-line no-console
  .catch((err) => console.error(err));

// declaring $kundo_chat on window so we can use it in navbar.component without transpilation errors
declare global {
  // special type for smartlook function which is a function with additional api property
  interface SmartlookFunction {
    (value1: string, value2: string, value3: unknown): void;
    api?: unknown[];
  }

  interface Window {
    $kundo_chat: {
      user: {
        name: string;
        email: string;
      };
      start_chat: () => void;
    };
    smartlook: SmartlookFunction;
    _paq: unknown[]; // Matomo tracking array
  }
}
